export const TEST_ID = 'reticleIcon';
